/* Share link: use the native share sheet on mobile, otherwise copy the link */
(function () {
    function legacyCopy(text) {
        const input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        let ok = false;
        try {
            ok = document.execCommand('copy');
        } catch (e) {}
        document.body.removeChild(input);
        return ok;
    }

    // The Clipboard API can be unavailable (http) or denied (embedded webviews), so fall back to execCommand
    function copy(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text).catch(function () {
                if (!legacyCopy(text)) throw new Error('copy failed');
            });
        }

        return legacyCopy(text) ? Promise.resolve() : Promise.reject(new Error('copy failed'));
    }

    document.querySelectorAll('[data-hc-share]').forEach(function (button) {
        button.addEventListener('click', function () {
            const url = button.getAttribute('data-url') || window.location.href;
            const title = button.getAttribute('data-title') || document.title;

            if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
                navigator.share({title: title, url: url}).catch(function () {});
                return;
            }

            copy(url).then(function () {
                toast('链接已复制，快去分享吧');
            }).catch(function () {
                window.prompt('请复制以下链接：', url);
            });
        });
    });
})();
